import { filter } from 'lodash';

import { AttributeType } from 'src/actions/rules/condition';
import customerProfileDefResource from 'src/actions/customer/customerProfileDefResource';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';

export default function useCustomAttributes() {
  const { value: profileDef } = useDocumentResource(customerProfileDefResource, { fetch: false });
  return filter(
    profileDef.attributes,
    item => [AttributeType.Currency, AttributeType.Number, AttributeType.String].indexOf(item.type) !== -1
  );
}
